/**
 * Collab 공통 유틸리티
 */

/**
 * seed 문자열로부터 HSL 색상 생성 (deterministic)
 * @param {string} seed
 * @returns {string} HSL 색상 문자열
 */
export function seedToColor(seed) {
  let hash = 0
  for (let i = 0; i < (seed || '').length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash)
  }
  return `hsl(${Math.abs(hash) % 360}, 70%, 50%)`
}

/**
 * contenteditable 안에서 특정 노드/오프셋의 텍스트 오프셋 계산
 * @param {HTMLElement} container
 * @param {Node} targetNode
 * @param {number} targetOffset
 * @returns {number}
 */
export function getTextOffset(container, targetNode, targetOffset) {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
  let offset = 0
  while (walker.nextNode()) {
    if (walker.currentNode === targetNode) return offset + targetOffset
    offset += walker.currentNode.textContent.length
  }
  return offset
}
